<template>
<div>
	<wrapper-edit
      :wrapper-width="wrapperWidth"
      @back="paasPageBack">
    <Form ref="paasForm" slot="form"
            :model="paasFormData"
            :rules="paasFormRules"
            :label-width="defaultLabelWidth">
       <Row>
          <FormItem label="卡名称：" prop="cardName" class="ivu-col-span-12" >
            <EntitySelect v-model="paasFormData.cardName"  :fieldConfig="executorConfig"
                          queryUrl="/eb/card/types/getTableData" @on-change="setEntitySelectData"></EntitySelect>

		      </FormItem>
          <FormItem label="制作数量：" prop="productNum" class="ivu-col-span-12" >
              <Input v-model="paasFormData.productNum"
                          clearable  search enter-button="张" ></Input>
		      </FormItem>
       </Row>
       <Row>
           <FormItem label="面额：" prop="faceValue" class="ivu-col-span-12" >

              <Input v-model="paasFormData.faceValue"
                          search enter-button="元"  readonly></Input>
           </FormItem>
           <FormItem label="售价：" prop="saleValue" class="ivu-col-span-12" >

                <Input v-model="paasFormData.saleValue"
                            clearable search enter-button="元" ></Input>
           </FormItem>
       </Row>
       <Row>
          <FormItem label="批次号：" prop="batchId" class="ivu-col-span-12" >

          <Input v-model="paasFormData.batchId"
                      clearable ></Input>
           </FormItem>
           <FormItem label="编码前缀：" prop="codePrefix" class="ivu-col-span-12" >
              <Input v-model="paasFormData.codePrefix"
                          clearable placeholer="限两个字母" ></Input>
           </FormItem>
       </Row>
       <Row>
          <FormItem label="备注：" prop="remarks" class="ivu-col-span-24" >

              <Input v-model="paasFormData.remarks"
                        type="textarea"  clearable ></Input>
          </FormItem>
       </Row>
       <div class="edit-oper-toolbar">
	      <Button type="primary" @click="confirmSave" style="margin-left: 8px">保存</Button>
	      <Button @click="paasPageBack" style="margin-left: 8px">返回</Button>
	    </div>
    </Form>

    </wrapper-edit>
</div>
</template>
<script>
import wrapperEdit from "@components/paas/wrapper-edit";
import metaEdit from "@assets/js/meta-edit.js";
import EntitySelect from '@components/paas/refer/entitySelect';

export default {
   name: "edit",
   mixins:[metaEdit],
   components:{wrapperEdit,EntitySelect},
   data(){
     return {
     	serviceUrl:"/eb/entity/card/batch/product",  //每个页面访问后台服务器的路径
      	currentIdFiledName: 'id',
        paasFormData:{
        	cardTypesId:'',
        	cardName:'',
        	faceValue:'',
        	saleValue:'',
        	batchId:'',
        	codePrefix:'',
        	codeStart:'',
        	productNum:'',
        	remarks:'',
        },
        paasFormRules:{
          codePrefix:[
            {required: true, message: "必输项不能为空", trigger: 'blur'},
            {validator:(rule, value, cb)=>{this.lenValid(value, 2, cb)}, trigger: 'blur'}
          ]
        },
		redirectName:"entityCardBatchProductList",
        nextAddName:"entityCardBatchProductEdit",
        executorConfig:{
           nameField:'cardName',
           nameFieldChild:'cardName',
           idField:'cardTypesId',
           idFieldChild:'id',
           otherField:"faceValue,saleValue@salePrice"
        },
     }
   },
   methods:{
     /**
      * 下拉参照
      * @param data
      */
     setEntitySelectData (data){
       for(let key in data){
         this.paasFormData[key] = data[key];
       }
     },
     /**
      * 校验输入的字符长度
      * @param str
      * @param num
      * @param cb
      * @returns {*}
      */
     lenValid(str, num, cb){
        if(str){
          let len = str.length;
          if(len > num){
            return cb(new Error('字段太长,卡前缀应为2位字母'))
          }
        }
        cb();
     },
     confirmSave(){
       let that = this;
       this.$swal({
         title: "确认您将生成"+this.paasFormData.productNum+"数量的"+this.paasFormData.cardName+"吗？",
         text: "一旦生成将无法撤销，请谨慎操作！",
         type: "warning",
         showCancelButton: true,
         confirmButtonColor: "#DD6B55",
         confirmButtonText: "是的，确认生成！",
         cancelButtonText: "稍等，还需修改",
         closeOnConfirm: false,
         closeOnCancel: false
       }).then((isConfirm)=> {
         if(isConfirm.value){
           this.$refs.paasForm.validate((valid) => {
             if (valid){
               that.axios.post(this.$store.state.sysApi+this.serviceUrl+"/save", that.paasFormData).then(res => {
                 if(res.code === 200) {
                   that.$Message.info('数据保存成功！');
                   that.paasFormSubmitAfter(res);
                   that.paasFormRouterPush(res,"");
                 }
               })
             }
           }).catch(function (error) {
             that.$Message.error('数据保存失败，请重试！');
           });

         }else{

         }
       })
     }
   }
}
</script>
